import SomethingWrongModal from './SomethingWrongModal';

export default SomethingWrongModal;



// WEBPACK FOOTER //
// ./src/components/SomethingWrongModal/index.js